export default __webpack_public_path__ + "static/media/background-sign-in.9a93e0b5.png";